/**
 * Alarm chip — the app-wide alarm-category pill.
 *
 * The same soft-tinted pill as StatusChip but without the indicator dot:
 * a status describes one state (the dot marks it), while alarms render in
 * groups where per-chip dots read as noise. Colors come from the same
 * semantic status palette (cssTokens.js --status-<family>); map alarm
 * severities via severityStatusFamily (@sophocles/utils/alarmSeverity).
 * Grid columns render lists of these via AlarmChipCell
 * (@sophocles/data-grids); non-grid surfaces use this directly.
 */
import React from 'react';

import StatusChip from './StatusChip';

/**
 * @param {object} props
 * @param {React.ReactNode} props.label - Short alarm text (already translated).
 * @param {'ok'|'warning'|'bad'|'info'|'attention'|'neutral'} [props.color]
 *   Status-palette family (see StatusChip / cssTokens.js).
 * @param {object} [props.sx] - Extra sx merged onto the pill.
 *   Remaining props (onClick, aria-*, …) and the ref forward to the pill
 *   element, so Tooltip can wrap it directly.
 */
const AlarmChip = React.forwardRef(function AlarmChip({ label, color = 'warning', sx = {}, ...rest }, ref) {
  return <StatusChip ref={ref} label={label} color={color} dot={false} sx={{ fontWeight: 600, ...sx }} {...rest} />;
});

export default AlarmChip;
